<template>
    <div>
        <input-label v-if="label" :for_element="name" :label_class="label_class"> {{ $t(label) }}</input-label>

        <select
            v-if="! read_only"
            class="select-native border border-gray-400 px-2 rounded text-black w-full h-input"
            :id="name"
            :name="name"
            v-model="selected_value"
            v-bind="$attrs"
            @change="$emit('input', selected_value)"
        >
            <option v-if="no_selection" value="">
                {{ no_selection }}
            </option>

            <option v-for="option in options"
                :value="option.value"
                :selected="option.value == selected_value"
            >
                {{ $t(option.label) }}
            </option>
        </select>

        <input-text
            v-else
            name="state"
            :value="selected_label"
            placeholder="State"
            :read_only="read_only"
        />
    </div>
</template>

<script>
export default {
    inheritAttrs: false,

    props: {
        label: {},
        label_class: {},
        name: {},
        value: {},
        options: { default: () => ({}) },
        no_selection: { default: 'Select' },
        read_only: { default: false },
    },

    data() {
        return {
            selected_value: this.value,
        }
    },

    computed: {
        selected_label() {
            let item = this.options.find(item => item.value == this.selected_value);

            return item ? item.label : this.selected_value;
        },
    },
}
</script>
